import { useState } from "react";

import { useStoreContext } from "../contexts/StoreDataContext";
import useCart from "../store/cart-store";
import Basket from "./Cart/Basket";
import Footer from "./Footer/Footer";
import StaticInfoBanner from "./Infobanner/StaticInfoBanner";
import NavBar from "./Navbar";
import SideNavDrawer from "./SideNavDrawer";

export const statusCopyClassName = "font-montserrat text-[16px] font-normal text-checkoutText";

/** `embedded` — already inside MainHome (banner + footer); skip duplicating them. */
const ShopStatusPage = ({ message, embedded = false }) => {
  const { storeData, themeData } = useStoreContext();
  const [showSideNav, setShowSideNav] = useState(false);
  const [showCart, setShowCart] = useState(false);

  const hasHydrated = useCart((s) => s.hasHydrated);
  const products = useCart((s) => s.products);
  const setCart = useCart((s) => s.setCart);

  const cart = { products };

  const body = (
    <>
      {hasHydrated && (
        <Basket
          isBasketOpen={showCart}
          setCart={setCart}
          cartData={cart}
          updateAddedToCart={() => {}}
          handleShowCart={setShowCart}
          store={storeData}
          setRefresh={() => {}}
        />
      )}

      <NavBar
        homePage
        store={storeData}
        storeName={storeData?.name || ""}
        theme={themeData}
        toggleSideNav={() => setShowSideNav((open) => !open)}
        sideNavOpen={showSideNav}
        handleShowCart={() => setShowCart(true)}
      />

      <SideNavDrawer
        isOpen={showSideNav}
        toggleDrawer={() => setShowSideNav((open) => !open)}
        handleShowCart={() => setShowCart(true)}
        store={storeData}
      />

      <p className={`mt-8 px-5 ${statusCopyClassName}`}>{message}</p>
    </>
  );

  if (embedded) return body;

  return (
    <div className="flex min-h-screen justify-center bg-[var(--side-bg-color)]">
      <main className="flex min-h-screen w-screen max-w-app flex-col bg-background font-montserrat">
        <StaticInfoBanner text={storeData?.announcement} />
        {body}

        <div className="mt-auto">
          <Footer />
        </div>
      </main>
    </div>
  );
};

export default ShopStatusPage;
